<template>
  <main class="flex flex-col justify-start h-screen overflow-auto" scroll-region>
    <slot />
  </main>
</template>
